import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { MdInputContainer, MdDatepicker, MdInputDirective } from '@angular/material';

import { PlantMapService } from '../services/plant-map.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { FileService } from '../../shared/services/file.service';

@Component({
    selector: 'plantmap-upload-document',
    templateUrl: 'upload-document.component.html'
})

export class PlantmapUploadDocumentComponent implements OnInit {

    @ViewChild('fileInput') vFileInput;

    currFile: number;

    constructor(
        private _plantmapService: PlantMapService,
        private _layoutService: LayoutService,
        private _pageNavigationService: PageNavigationService,
        private _popupService: PopupService,
        private _storageService: StorageService,
        private _fileService: FileService
    ) {

    }

    ngOnInit() {
        this._layoutService.setCurrentPage('plantmap-upload-document');
        this._plantmapService.resetPlantMapData();
        this._plantmapService.resetUploadDocumentData();
        if (this._plantmapService.getAreaOfInterestData().restricted_area === 0 || this._plantmapService.getAreaOfInterestData().restricted_area === -1
            || this._plantmapService.getRequestId() === ''
        ) {
            this._pageNavigationService.navigate(['home']);
        }
    }

    isLoading() {
        return this._fileService.isLoading();
    }

    getFileList() {
        return this._fileService.getFileLists();
    }

    goBack() {
        let vLink = ['plant-map/area-of-interest'];
        this._pageNavigationService.navigate(vLink);
    }

    fileEvent(fileInput: any) {
        let file = fileInput.target.files[0];
        this.currFile = this._fileService.vFiles.length;
        if (!this._fileService.validateUploadedFile(file)) {
            this.vFileInput.nativeElement.value = "";
            return;
        }
        this._fileService.vFiles.push(file.name);
        //alert('calling file event');
        //this._fileService.getSignedRequest(file, 'plantmap', 'restricted_area', this._plantmapService.getRequestId(), this._plantmapService.getRecordId()); //GANESH
        // let requestIdforGis:any = this._plantmapService.getRequestId().split("-");//GANESH

        // this._fileService.getSignedRequest(file, 'PlantMap_Invoice', requestIdforGis[3], 'restricted_area',  this._plantmapService.getRecordId());
        // this._fileService.getSignedRequest(file, 'PlantMap', 'restricted_area', this._plantmapService.getRequestId(), this._plantmapService.getRecordId());

        this._fileService.uploadPlantMapRestrictedAreaAttachmentToDMS(file, this._plantmapService.getRecordId());


        this.vFileInput.nativeElement.value = "";
    }

    removeAttachment(pIndex, pFileName) {
        this.currFile = pIndex;
        this._fileService.deleteFiles(this._plantmapService.getRequestId(), 'plantmap', 'restricted_area', pFileName).then(
            (resolve) => {
                this._fileService.vFiles.splice(pIndex, 1);
                this._popupService.openGeneralConfirmationPopup('Notice', 'File successfully deleted', '', false, false);
                this._storageService.setSessionItem('plantmapFiles', JSON.stringify(this._fileService.getFileLists()));
            },
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Notice', 'Error delete file, please try again', '', false, false);
            }
        );
    }

    isDisableSaveUpload() {
        return this._plantmapService.isDisableSaveUpload();
    }

    submitUploadDocument() {
        // let restrictedArea_skip_payment: true;

        this._plantmapService.submitPayment_res('true');
        //this._pageNavigationService.navigate(['plant-map/payment']);

        //this._pageNavigationService.navigate(['plant-map/payment']);
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/upload-document.component.ts